
import { RdExpenditureYear } from './rd-expenditure-year.model';

export class LqreCalculation {
  detectedFormType: string;
  years: RdExpenditureYear[];

  constructor(taxCreditCalculation?: any) {
    if (taxCreditCalculation) {
      Object.assign(this, taxCreditCalculation);
    }
  }
}
